import {
    api
} from '../config'
import { getToken } from './common'

const appendOptionalFormValues = (formdata, key, value) => {
    if (value === undefined || value === null || value === '') {
        return
    }

    if (Array.isArray(value)) {
        value
            .filter((item) => item !== undefined && item !== null && item !== '')
            .forEach((item, index) => {
                const normalized = key === 'term' ? +item : item
                if (key === 'term' ? normalized : true) {
                    formdata.append(`${key}[${index + 1}]`, normalized)
                }
            })
        return
    }

    if (key === 'term') {
        if (+value) formdata.append(key, +value)
        return
    }

    formdata.append(key, value)
}

export const fetchMarketPrice = async (utilityId /*, tduRequest*/ ) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', utilityId)
    // formdata.append('tdu_request', tduRequest)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/market_price`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchLoginMarketPrice = async (utilityId /*, tduRequest*/ ) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', utilityId)
    // formdata.append('tdu_request', tduRequest)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/market_price`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchUtilityId = async () => {
    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/get_utility`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchMyProviderInfo = async (utility_id) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', utility_id)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/get_login_provider`
    const response = await fetch(url, requestOptions)
    return response.json()
}
export const fetchLoginProviderList = async () => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/get_provider`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchAvgPrice = async (value) => {
    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    // formdata.append('tdu_request', value.tdu_request)
    // formdata.append('date', value.date)
    appendOptionalFormValues(formdata, 'term', value.term ?? value.terms)
    if (+value.type) formdata.append('type', +value.type)
    if (value.plan_type !== undefined && value.plan_type !== '' && value.plan_type !== null) formdata.append('plan_type', value.plan_type)
    appendOptionalFormValues(formdata, 'source', value.source ?? value.sources)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    if (+value.compare_provider_id) formdata.append('compare_provider_id', +value.compare_provider_id)
    if (+value.download) formdata.append('download', +value.download)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Trend/market_average_price`
    const response = await fetch(url, requestOptions)
    if (+value.download) {
        return response
    }
    return response.json()
}

export const fetchTxDownloadPrice = async (value) => {
    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    // formdata.append('tdu_request', value.tdu_request)
    // formdata.append('date', value.date)
    appendOptionalFormValues(formdata, 'term', value.term ?? value.terms)
    if (value.plan_type !== undefined && value.plan_type !== '' && value.plan_type !== null) formdata.append('plan_type', value.plan_type)
    appendOptionalFormValues(formdata, 'source', value.source ?? value.sources)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    if (+value.download) formdata.append('download', +value.download)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Trend/market_price`
    const response = await fetch(url, requestOptions)
    if (+value.download) {
        return response
    }
    return response.json()
}

export const fetchLoginAvgPrice = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    // formdata.append('tdu_request', value.tdu_request)
    formdata.append('date', value.date)
    appendOptionalFormValues(formdata, 'term', value.term ?? value.terms)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    if (value.plan_type !== undefined && value.plan_type !== '' && value.plan_type !== null) formdata.append('plan_type', value.plan_type)
    appendOptionalFormValues(formdata, 'source', value.source ?? value.sources)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/market_average_price`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchLowestPrice = async (value) => {
    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    // formdata.append('tdu_request', value.tdu_request)
    // formdata.append('date', value.date)
    appendOptionalFormValues(formdata, 'term', value.term ?? value.terms)
    appendOptionalFormValues(formdata, 'source', value.source ?? value.sources)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Trend/market_lowest_price`
    const response = await fetch(url, requestOptions)
    return response.json()
}
export const fetchLoginLowestPrice = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    // formdata.append('tdu_request', value.tdu_request)
    formdata.append('date', value.date)
    appendOptionalFormValues(formdata, 'term', value.term ?? value.terms)
    appendOptionalFormValues(formdata, 'source', value.source ?? value.sources)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/market_lowest_price`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchSourceList = async () => {
    const requestOptions = {
        method: 'GET',
        redirect: 'follow',
    }
    const url = `${api.API_URL}Trend/source_list`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchTerms = async (utility_id) => {
    const formdata = new FormData()
    formdata.append('utility_id', utility_id)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/get_all_term`
    const response = await fetch(url, requestOptions)
    return response.json()
}
export const fetchLoginTerms = async (provider_id, utility_id) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', utility_id)
    formdata.append('provider_id', provider_id)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/get_all_term`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchTopPlanList = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    formdata.append('created_ts', value.created_ts)
    if (+value.term) formdata.append('term', +value.term)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    if (value.plan_type !== undefined && value.plan_type !== '' && value.plan_type !== null) formdata.append('plan_type', value.plan_type)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}TopPlan/index`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchTopPlanDetail = async (plan_id, price, created_ts, date) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('plan_id', plan_id)
    formdata.append('price', price)
    formdata.append('created_ts', created_ts)
    formdata.append('date', date)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}TopPlan/top_plan_detail`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const exportTopPlanList = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    formdata.append('created_ts', value.created_ts)
    if (+value.term) formdata.append('term', +value.term)
    if (+value.provider_id) formdata.append('provider_id', +value.provider_id)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}TopPlan/export_top_plan`
    const response = await fetch(url, requestOptions)
    return response
}

export const fetchInfo = async () => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        // body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}CompanyInformation/get_information`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const saveInfo = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('email', value.email)
    formdata.append('plan_picker', value.plan_picker)
    formdata.append('plan_report', value.plan_report)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}CompanyInformation/store_information`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchRace = async (utility_id, idArr, price) => {
    const formdata = new FormData()
    formdata.append('utility_id', utility_id)
    for (let index = 0; index < idArr.length; index++) {
        formdata.append(`provider_id[${index}]`, idArr[index])
    }
    formdata.append('price', price)
    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/mobility_rank`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchProviders = async () => {

    const requestOptions = {
        method: 'GET',
        // headers: myHeaders,
        // body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}Home/get_provider`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const contactUs = async (value) => {
    const formdata = new FormData()
    formdata.append('email', value.email)
    formdata.append('message', value.question)
    formdata.append('name', `${value.last_name} ${value.first_name}`)
    formdata.append('company', value.company)
    formdata.append('site', 'PowerRateIndex')

    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `https://www.powerlego.com/contact/website`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const getPlanNum = async (utility_id) => {
    const requestOptions = {
        method: 'GET',
        // headers: myHeaders,
        // body: formdata,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}Home/get_plan_provider_number${utility_id ? `?utility_id=${utility_id}` : ""}`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchAllProviderList = async () => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
    }
    const url = `${api.API_URL}PowerRateIndex/providers`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const updateProvider = async (provider_id, usn_provider_id) => {

    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('provider_id', provider_id)
    formdata.append('usn_provider_id', usn_provider_id)

    const requestOptions = {
        method: 'POST',
        // headers: myHeaders,
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
        // responseType: 'blob',
    }
    const url = `${api.API_URL}PowerRateIndex/editProvider`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchAverageRateList = async (value) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)

    const formdata = new FormData()
    formdata.append('utility_id', value.utility_id)
    formdata.append('price', value.price)
    
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Home/averagerate`
    const response = await fetch(url, requestOptions)
    return response.json()
}

export const fetchTduHistory = async (utility_id, months) => {
    const newToken = await getToken()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${newToken}`)
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

    const formdata = new URLSearchParams()
    formdata.append('utility_id', utility_id)
    months.forEach((month, index) => {
        formdata.append(`months[${index}]`, month)
    })

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
    }
    const url = `${api.API_URL}Market/tdu_history`
    const response = await fetch(url, requestOptions)
    return response.json()
}